const Join = 
{
    setColorClass(target, color) 
    {
        if (target.classList.contains("red")) {
            target.classList.remove("red");
        }
        if (target.classList.contains("blue")) {
            target.classList.remove("blue");
        }
        if (target.classList.contains("black")) {
            target.classList.remove("black");
        }
        target.classList.add(color);
    },
}

export {
    Join
}

